import { filter, propEq } from 'ramda'
import { useQuery } from 'react-query'

import { CustomerAPI } from 'api'
import { PropertyDefinition } from 'types/contacts'

const getContactAttributes = (url: string) =>
  CustomerAPI.get<PropertyDefinition[]>(url).then((res) =>
    filter(propEq('status', 'ENABLED'), res.data)
  )

export const useContactAttributes = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['property_definitions'],
    queryFn: ({ queryKey }) => getContactAttributes(queryKey[0]),
    refetchOnWindowFocus: false,
  })

  return {
    data,
    isLoading,
    error,
  }
}

export default useContactAttributes
